export default __webpack_public_path__ + "static/media/brain.2e2630bc.gif";